import React from 'react'

import "./Input.css"

const Input = ({id, label, ...props}) => {
    return (
        <div className="input">
            <input className="field" placeholder='' type="text" id={id} {...props}/>
            <label htmlFor={id} className="label">{label + (props.required ? "*" : "")}</label>
            <div className='underline'/>
        </div>
    )
}   

export default Input